/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S2_Li3Inputs */

const tr_servis_s2_li3 = /** @type {(inputs: Servis_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatura, QNB eSolutions üzerinden e-Arşiv / e-Fatura olarak düzenlenir ve Kullanıcı'ya iletilir.`)
};

const en_servis_s2_li3 = /** @type {(inputs: Servis_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The invoice is issued as e-Arşiv / e-Fatura through QNB eSolutions and delivered to the User.`)
};

const de_servis_s2_li3 = /** @type {(inputs: Servis_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Rechnung wird über QNB eSolutions als e-Arşiv / e-Fatura ausgestellt und dem Nutzer übermittelt.`)
};

const ru_servis_s2_li3 = /** @type {(inputs: Servis_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Счет оформляется как e-Arşiv / e-Fatura через QNB eSolutions и передается Пользователю.`)
};

/**
* | output |
* | --- |
* | "The invoice is issued as e-Arşiv / e-Fatura through QNB eSolutions and delivered to the User." |
*
* @param {Servis_S2_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s2_li3 = /** @type {((inputs?: Servis_S2_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S2_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s2_li3(inputs)
	if (locale === "de") return de_servis_s2_li3(inputs)
	if (locale === "ru") return ru_servis_s2_li3(inputs)
	return tr_servis_s2_li3(inputs)
});